/**
 *
 *
 *
 *
 *
 *
 */
export const waitForNextAnimationFrame = (): Promise<number> => new Promise(requestAnimationFrame);
